import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { accountsToFilterOut } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { Privileges } from 'src/app/privileges/privileges';
import { ActiveCallsRegister } from '../../active-calls-register';
import { ActiveCallsFilterOptions } from '../../models/active-calls-filter-option';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import * as SystemActiveCallsActions from '../../state/system-active-calls/system-active-calls.actions';
import * as systemActiveCallsRegisterReducer from '../../state/system-active-calls/system-active-calls.reducer';
import { selectSortedActiveCalls } from '../../state/system-active-calls/system-active-calls.selectors';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-system-active-calls-register',
   templateUrl: './system-active-calls-register.component.html',
   standalone: false,
})
export class SystemActiveCallsRegisterComponent extends ActiveCallsRegister {
   constructor(public store: Store) {
      super(
         store,
         systemActiveCallsRegisterReducer.selectors,
         SystemActiveCallsActions.systemActiveCallsRegisterAdapterActions
      );
      this.dataSource$ = this.store.pipe(select(selectSortedActiveCalls));
      this.store
         .select(accountsToFilterOut(Privileges.ManageCallDetails_View))
         .pipe(
            map((accountIds: number[]) => {
               if (accountIds.length > 0) {
                  const filters: ActiveCallsFilterOptions[] = [
                     {
                        field: 'AccountId',
                        operation: FilterOperations.NotIn,
                        type: 'numeric',
                        value: accountIds,
                     },
                  ];
                  return filters;
               } else {
                  const filters: ActiveCallsFilterOptions[] = [];
                  return filters;
               }
            })
         )
         .subscribe((filters: ActiveCallsFilterOptions[]) => {
            this.filters = filters;
         });
      this.columns = [
         'accountName',
         'callDirection',
         'callSource',
         'callDestination',
         'callCost',
         'callDuration',
         'sourceProvider',
         'destinationProvider',
         'activeCallsActionsMenu',
      ];
   }

   onOpenDialog(event: { callLogs: any }) {
      this.store.dispatch(SystemActiveCallsActions.openDialog(event));
   }

   onHangupActiveCall(event: { activeCall: ActiveCallsRegisterListItem }) {
      this.store.dispatch(SystemActiveCallsActions.hangupActiveCall(event));
   }

   getInitialFilterAction() {
      return SystemActiveCallsActions.systemActiveCallsRegisterInitialFilter({ filters: this.filters });
   }
   getCreateAction() {
      return SystemActiveCallsActions.createActiveCalls();
   }
}
